import { create } from 'zustand';
import { message } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import { getCachedData, setCachedData, clearCacheByKey } from '../utils/cacheUtil';

const usePlatformStore = create((set) => ({
  platforms: [],
  loading: false,
  error: null,

  fetchPlatforms: async () => {
    const cached = getCachedData('platforms');
    if (cached) {
      set({ platforms: cached, loading: false, error: null });
      return;
    }

    set({ loading: true });
    try {
      const response = await axiosInstance.get('/platforms/');
      setCachedData('platforms', response.data);
      set({ 
        platforms: response.data,
        loading: false,
        error: null 
      });
    } catch (error) {
      set({ error: error.message, loading: false });
      message.error('Failed to fetch platforms');
    }
  },

  createPlatform: async (platformData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.post('/platforms/', platformData);
      clearCacheByKey('platforms');
      set(state => ({
        platforms: [...state.platforms, response.data],
        loading: false,
      }));
      message.success('Platform created successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to create platform');
      return { success: false, error };
    }
  },

  updatePlatform: async (id, platformData) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.put(`/platforms/${id}/`, platformData);
      clearCacheByKey('platforms');
      set(state => ({
        platforms: state.platforms.map(platform => 
          platform.id === id ? response.data : platform
        ),
        loading: false,
      }));
      message.success('Platform updated successfully');
      return { success: true, data: response.data };
    } catch (error) {
      set({ loading: false });
      message.error('Failed to update platform');
      return { success: false, error };
    }
  },

  deletePlatform: async (id) => {
    try {
      await axiosInstance.delete(`/platforms/${id}/`);
      clearCacheByKey('platforms');
      set(state => ({
        platforms: state.platforms.filter(platform => platform.id !== id),
      }));
      message.success('Platform deleted successfully');
      return { success: true };
    } catch (error) {
      message.error('Failed to delete platform');
      return { success: false, error };
    }
  },
}));

export default usePlatformStore;
